import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";

const UjjivanBank = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
  ?.filter((card) => card.title?.toLowerCase().includes("ujjivan"))
  .slice(indexOfFirstCard, indexOfLastCard);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question: "Do Ujjivan Small Finance Bank credit cards have annual fees?",
      answer:
        "Some Ujjivan cards offer zero annual fees or waivers on milestone spending, especially suited for new users.",
    },
    {
      question: "Can I apply without a credit score?",
      answer:
        "Yes, Ujjivan may allow first-time credit applicants, especially existing savings account holders, subject to income verification.",
    },
    {
      question: "Are Ujjivan credit cards internationally accepted?",
      answer:
        "Most Ujjivan cards are Rupay or Mastercard/Visa-enabled, allowing domestic and selective international transactions.",
    },
    {
      question: "How can I repay my Ujjivan credit card bills?",
      answer:
        "Payments can be made via net banking, UPI, NEFT, or through auto-debit from your Ujjivan account.",
    },
    {
      question: "Is there a mobile app to manage my credit card?",
      answer:
        "Yes, you can manage your card via the Ujjivan SFB Mobile Banking App, which offers access to statements, payment tracking, and limit checks.",
    },
  ];

  const steps = [
  
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Verify Your Eligibility",
      description:
        "Check your income, age, credit score, and residential city to ensure you meet Ujjivan’s card criteria.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Collect Required Documents",
      description:
        "Prepare your ID proof, address proof, income documents, and PAN card to speed up the application process.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Apply on Ujjivan’s Official Website",
      description:
        "Once you've selected the ideal card, click “Apply Now” to be redirected to Ujjivan Small Finance Bank’s official portal, where you can submit your application securely.",
    },
    {
        icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
        title: "Explore & Compare with TheFinMaster",
        description:
          "Visit TheFinMaster to explore top Ujjivan credit cards, compare features like reward points, interest rates, charges, and eligibility. Each card profile is curated to help you choose the one best suited to your financial lifestyle.",
      },
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Ujjivan Small Finance Bank Credit Card 2024 - Compare & Apply Online
          at TheFinmaster
        </title>
        <meta
          name="description"
          content="Ujjivan Small Finance Bank Credit Cards - Check all types of Ujjivan SFB credit cards list & their benefits to select the right card for you. Apply for top & best Ujjivan credit card now. | TheFinmaster"
        />
        <meta
          name="keywords"
          content="ujjivan small finance bank credit card, ujjivan credit card apply, ujjivan credit card benefits, ujjivan credit card eligibility, ujjivan sfb credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/ujjivan-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Credit Card
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Inclusive and Rewarding Credit Solutions from Ujjivan Small Finance
              Bank
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              Ujjivan Small Finance Bank brings accessible and innovative credit
              card options that are tailored to meet the everyday financial needs
              of India's underserved and emerging customer segments. Whether
              you're a first-time credit user or looking for a card that offers
              real value through utility rewards, Ujjivan ensures a simple,
              transparent, and secure credit experience. Their cards focus on
              smart spending, low charges, and practical benefits ideal for urban
              and semi-urban users.
            </p>
          </div>
        </div>
        <h1 className="text-center text-2xl md:text-3xl font-bold text-gray-800  my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                    key={index}
                    cardDetails={item}
                    Card_features={item?.Card_features}
                    fees={item?.fees}
                    cardName={item?.title}
                    cardImage={item?.image}
                    rating={item?.rating}
                    category={item?.category}
                    status={item?.status}
                    bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>
<div className="w-full relative ">
                              <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                                {/* <div className="w-[70%] mx-auto">
                                                           <h2 className="text-center font-medium pt-5 text-lg">
                                                             <span className="font-semibold text-white">816 people</span>{" "}
                                                             are on call with our advisors right now
                                                           </h2>
                                                         </div> */}
                                <div className="w-full mx-auto">
                                  <Link
                                    to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <div className="w-[80%] mx-auto ">
                                      <img src="/assets/new.png" alt="Advertisement" />
                                    </div>
                                  </Link>
                                  <div className="bg-white">
                                    {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                               Know your advisor
                                                             </h3> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

       

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for Ujjivan Small Finance Bank
                  Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Age Requirement
                  </span>
                  <span>
                    Applicants must be between 21 to 65 years for the primary
                    card. Add-on cards are issued to users aged 18 years and
                    above.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Income Requirement
                  </span>
                  <span>
                    For salaried professionals, a net monthly income of
                    ₹15,000–₹20,000 is typically required. Self-employed
                    individuals must show a steady cash flow or business turnover
                    as per bank policies.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Credit Score Requirement
                  </span>
                  <span>
                    A CIBIL score of 700 or above is generally expected, though
                    flexible underwriting may apply for first-time credit users or
                    existing Ujjivan customers.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type
                  </span>
                  <span>
                    Applicants can be salaried, self-employed, or small business
                    owners. Ujjivan prioritizes inclusive eligibility, especially
                    for financially underserved communities.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Geographical Coverage
                  </span>
                  <span>
                    Ujjivan credit cards are offered in cities and towns where
                    Ujjivan Small Finance Bank branches operate. Applicants must
                    reside in a bank-serviced region.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for Ujjivan Small Finance Bank
                  Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Identity Proof
                  </span>
                  <span>
                    Valid government-issued ID like Aadhaar, PAN, Passport, or
                    Driving License is required for identity verification.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Address Proof
                  </span>
                  <span>
                    Utility bills, Aadhaar, passport, or a registered rent
                    agreement can be used as proof of residence.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    Salaried: Recent 3 months’ salary slips or Form 16.
                    Self-employed: Bank statements, ITRs, or business turnover
                    documents accepted by the bank.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    Mandatory for all applications to validate financial track
                    record and for credit reporting.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Passport-Sized Photograph
                  </span>
                  <span>
                    Required for physical applications and KYC records.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for Ujjivan Small Finance Bank Credit Card
        </h2>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default UjjivanBank;